import { render, staticRenderFns } from "./QuestionBox.vue?vue&type=template&id=4e324539&scoped=true"
import script from "./QuestionBox.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionBox.vue?vue&type=script&setup=true&lang=js"
import style0 from "./QuestionBox.vue?vue&type=style&index=0&id=4e324539&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e324539",
  null
  
)

export default component.exports